import type { TypedUseSelectorHook } from "react-redux";
import { useDispatch, useSelector } from "react-redux";

import type { AppDispatch, RootState } from "./store";

/**
 * Typed version of useDispatch for the unified store.
 * Use this throughout the app instead of plain useDispatch.
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();

/**
 * Typed version of useSelector for the unified store.
 * Use this throughout the app instead of plain useSelector.
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
